import React, { Component } from "react";
import { RightOutlined } from "@ant-design/icons";

import { Layout, Breadcrumb, Button, PageHeader } from "antd";

import SurgicalInterventionTable from "./SurgicalInterventionTable";
import SurgicalInterventionForm from "./SurgicalInterventionForm";

const { Content } = Layout;

/**
 *
 */
class SurgicalIntervention extends Component {
  /**
   *
   * @param {*} props
   */
  constructor(props) {
    super(props);

    this.state = {
      showForm: false,
      selectedSurgicalIntervention: null,
    };

    this.surgicalInterventionsTable = React.createRef();

    this.onCreatedHandler = this.onCreatedHandler.bind(this);
    this.onAddHandler = this.onAddHandler.bind(this);
  }

  componentDidMount() {
    const stateHistory = (!!window.history.state) ? window.history.state.state : undefined;
    if (stateHistory !== undefined && stateHistory.hasOwnProperty("event")) {
      if (stateHistory.event === "create_intervention") {
        this.onAddHandler();
      }
    }
  }

  /**
   *
   */
  onCreatedHandler = () => {
    this.surgicalInterventionsTable.current.fetch({
      current: 1,
      pageSize: 10,
    });

    this.setState({
      showForm: false,
    });
  };

  /**
   *
   */
  onAddHandler = () => {
    this.setState({
      showForm: true,
    });
  };

  render() {
    return (
      <Content
        style={{
          margin: "24px 16px",
          padding: 24,
          minHeight: 280,
        }}
      >
        <Breadcrumb
          style={{ padding: 24 }}
          separator={<RightOutlined style={{ fontSize: "75%" }} />}
        >
          <Breadcrumb.Item>
            <a href="/home">Accueil</a>
          </Breadcrumb.Item>
          <Breadcrumb.Item>Listing Séjours</Breadcrumb.Item>
        </Breadcrumb>
        <PageHeader
          ghost={false}
          title="Listing Séjours"
          extra={[
            <Button
              key="add"
              type="primary"
              size="large"
              onClick={this.onAddHandler}
            >
              Nouveau séjour
            </Button>,
          ]}
        />
        <div
          className="site-layout-background"
          style={{ padding: 24, minHeight: 360 }}
        >
          <SurgicalInterventionTable
            ref={this.surgicalInterventionsTable}
          />
          <SurgicalInterventionForm
            onCreated={this.onCreatedHandler}
            onClose={() => {
              this.setState({
                showForm: false,
                selectedSurgicalIntervention: null,
              });
            }}
            visible={this.state.showForm}
            surgicalIntervention={this.state.selectedSurgicalIntervention}
          />
        </div>
      </Content>
    );
  }
}

export default SurgicalIntervention;
